/**
 * Created by bergutov_rr on 01.06.17.
 */
import Raven from 'raven-js';
import './polyfills';
import './extensions';
import $ from "jquery";

const production = process.env.NODE_ENV === "production";

window.is_mobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
if(window.is_mobile)
    $('body').addClass('is_mobile');
else
    $('body').addClass('is_desktop');

if (production) {
    Raven.config('https://66d7f9f62cc3401eac736ffb0cb92938@sentry.tgt72.ru/13', {
        ignoreUrls: [
            // Woopra flakiness
            /eatdifferent\.com\.woopra-ns\.com/i,
            /static\.woopra\.com\/js\/woopra\.js/i,
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            // Other plugins
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
        ]
    }).install();
}

export function logger(error) {
    if (production) {
        Raven.captureException(error);
    } else {
        console.log(error);
    }
}

export function formatDate(date) {

    let dd = date.getDate();
    if (dd < 10) dd = '0' + dd;

    let mm = date.getMonth() + 1;
    if (mm < 10) mm = '0' + mm;

    let yy = date.getFullYear();

    return `${yy}-${mm}-${dd}`;
}

export function groupBy(array, key) {
    return array.reduce((rv, x) => {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

export const constants = {
    host: (production) ? 'https://api.tgt72.ru' : 'http://api.tgt72.ru',
    production: production,
    lite_map: $('body').hasClass('lite-map'),
    show_video: true,
    show_cookie_window: false
};

if (constants.show_cookie_window) {
    $(document).ready(function () {
        var cookieName = "showBannerCookies";
    
        function createCookie(name, value, days) {
            var expires;
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
            return true;
        }
    
        function getCookie(c_name) {
            if (document.cookie.length > 0) {
                var c_start = document.cookie.indexOf(c_name + "=");
                if (c_start != -1) {
                    c_start = c_start + c_name.length + 1;
                    var c_end = document.cookie.indexOf(";", c_start);
                    if (c_end == -1) {
                        c_end = document.cookie.length;
                    }
                    return decodeURIComponent(document.cookie.substring(c_start, c_end));
                }
            }
            return '';
        }
    
        var cookie = getCookie(cookieName);
        $("#cookieBanner").toggle(cookie == '', "slow");
    
        $("#acceptCookies").click(function () {
            createCookie(cookieName, 1, 365);
            $("#cookieBanner").toggle("slow");
        });
    });
}

if (constants.lite_map) {
    $(document).ready(function () {
        $('*').bind('contextmenu', function(e) { return false; });
    });
}


// WEBPACK FOOTER //
// ./src/js/common.js